import { render, staticRenderFns } from "./CompanyIAShipParticular.vue?vue&type=template&id=7ad1072e&scoped=true&"
import script from "./CompanyIAShipParticular.vue?vue&type=script&lang=js&"
export * from "./CompanyIAShipParticular.vue?vue&type=script&lang=js&"
import style0 from "./CompanyIAShipParticular.vue?vue&type=style&index=0&id=7ad1072e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad1072e",
  null
  
)

export default component.exports